import React from "react";
import { connect } from "react-redux";
import { getAllLayouts } from "../../state/dashboard-layouts/selectors";
import { getName, getLayoutId } from "../../state/dashboard/selectors";
import { switchLayout } from "../../state/dashboard/actions";
import DropdownSelect from "../../components/dropdown-select";

const SwitchReportDropdownSelect = ({
  dashboards = [],
  activeDashboardId,
  switchDashboard,
}) => {
  const handleOnDashboardSelect = (id) => {
    switchDashboard(id);
  };

  return (
    <DropdownSelect
      selected={activeDashboardId}
      onChange={handleOnDashboardSelect}
      options={dashboards.map((d) => ({
        key: d.id,
        value: d.id,
        label: d.name,
      }))}
    />
  );
};

export default connect(
  (state) => {
    return {
      dashboards: getAllLayouts(state),
      activeDashboardId: getLayoutId(state),
      activeDashboardDescription: getName(state),
    };
  },
  {
    switchDashboard: switchLayout,
  }
)(SwitchReportDropdownSelect);
